import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import storage from '../../../components/DeviceStorage/DeviceStorage';
import { Dates } from '../../../packages/dates';
import Utils from 'src/utils/Utils';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class RemoveLiveChannelTask extends AbstractRequestTask {
    constructor(uri, object_id = '') {
        super();
        const user_hash = storage.getItem("user_hash") || "";
        const _now = Utils.nowAsTimestampSeconds();
        const now = new Dates().unix(_now).format('DD/MM/YYYY HH:mm:ss');

        this.uri = uri;
        this.params = {
            object_id,
            user_hash,
            date: now 
        };
    }

    getHeaders() {
        return {};
    }

    getShowModal() {
        return true;
    }

    getUrl() {
        const http = "http://";
        const url = Launcher.get("akamai_mfwk");

        return `${http}${url}` + this.uri;
    }

    isValid(data) {
        if (data.errors || data.status == 1 || data.response === 'error') {
            return false;
        }
        return true;
    }

    getParams() {
        let params = super.getParams();

        return Object.assign({}, params, this.params);
    }

    success(data, b) {
        this.resolve(data);
    }

    getShowErrorModal(){
        return ENABLE_MODAL_RETRIES;
    }
}

export default RemoveLiveChannelTask;


// WEBPACK FOOTER //
// ./src/requests/tasks/cms/RemoveLiveChannelTask.js